import React from 'react';

import { MenuItem } from 'types/menuTypes';
import { renderDynamicComponent } from 'utils/componentRegistry';

interface RenderMenuContentProps {
  menu?: MenuItem | null;
  children?: React.ReactNode;
}

const RenderMenuContent: React.FC<RenderMenuContentProps> = ({ menu, children }) => {
  if (!menu) return <>{children}</>;

  return <>{renderDynamicComponent({ menu, children })}</>;
};

export default RenderMenuContent;
